import { IStringVal } from 'app/interfaces/IStringVal';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Owned } from 'app/model/base/named';

@Metamodel.model({})
export class DatabricksParameter extends Owned implements IStringVal {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['Any'],
        association: 'VALUE'
    })
    public value: string = '';
}
